module.exports = __webpack_public_path__ + "static/media/9DESA10.d37fb2cc.jpg";